//component
import Col from "../element/col";
import Row from "../element/row";
import Icon from "../element/icon";
import Image from "../element/image";

//assets
import { Logo } from "../../assets/images";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CartDropdown from "../dropdown/cart.dropdown";
import {
  closeCartDropdown,
  closeShopDropdown,
  openCartDropdown,
  openShopDropdown,
} from "../../redux/reducer/common.reducer";
import ShopDropdown from "../dropdown/shop.dropdown";
import useWindowDimension from "../hook/use.window.dimension";
import { openLoginModal } from "../../redux/reducer/modal.reducer";
import { showToast } from "../../helpers/show.toast";

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { width } = useWindowDimension();
  const {
    token,
    menuList,
    pageList,
    cartCount,
    isOpenCartDropdown,
    isOpenShopDropdown,
  } = useSelector((state) => state.common);

  const handleNavigate = (page) => {
    navigate(page);
  };

  return (
    <header
      className="header"
      onMouseLeave={() => {
        dispatch(closeShopDropdown());
        dispatch(closeCartDropdown());
      }}
    >
      <Image
        tag="section"
        src={Logo}
        alt="logo"
        className="_img logo pointer"
        onClick={() => handleNavigate("/")}
      />
      <Row tag="section" className="_row page">
        <Row className={width > 500 ? "gap-5" : "gap-4"}>
          {pageList.map(
            (page, pageIndex) => (
              // (width > 500 || pageIndex === 0) && (
              <Col
                id={page.label}
                key={pageIndex}
                className="_col page pointer relative"
                onClick={() => {
                  if (page.navigate) {
                    handleNavigate(page.navigate);
                    dispatch(closeShopDropdown());
                  }
                }}
                onMouseEnter={() => {
                  if (
                    page.label === "shop" &&
                    window?.matchMedia("(hover: hover)")?.matches
                  ) {
                    dispatch(openShopDropdown());
                    dispatch(closeCartDropdown());
                  }
                }}
              >
                <h5 className="_label page">{page.label}</h5>
                {page.icon && <Icon className="_svg page" icon={page.icon} />}
                {page.label === "shop" && isOpenShopDropdown && (
                  <ShopDropdown />
                )}
              </Col>
            )
            // )
          )}
        </Row>
        <Row className={width > 500 ? "gap-4" : "gap-3"}>
          {menuList.map((menu, menuIndex) => (
            <Col
              key={menuIndex}
              className="_col menu pointer relative"
              onClick={() => {
                if (menu.navigate === "/order" && !token) {
                  dispatch(openLoginModal());
                  showToast(
                    "You're not logged in!",
                    "Please log in to stay updated on your order.",
                    "error"
                  );
                  return;
                }

                if (menu.navigate === "/cart" && cartCount === 0) {
                  showToast(
                    "Your cart is empty!",
                    "Add something to your cart before checkout.",
                    "error"
                  );
                  return;
                }

                if (menu.navigate) {
                  handleNavigate(menu.navigate);
                  dispatch(closeCartDropdown());
                } else {
                  if (token) {
                    showToast(
                      "Logged Out",
                      "You have been logged out. See you again soon!"
                    );
                    localStorage.clear();

                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  } else {
                    dispatch(openLoginModal());
                  }
                }
              }}
              onMouseEnter={() => {
                if (
                  menu.label === "cart" &&
                  pathname !== "/cart" &&
                  window?.matchMedia("(hover: hover)")?.matches
                ) {
                  dispatch(openCartDropdown());
                  dispatch(closeShopDropdown());
                }
              }}
            >
              {menu.label === "cart" && cartCount > 0 && (
                <p className="_label count">{cartCount}</p>
              )}
              <Icon
                icon={
                  menu.label === "user" && token ? menu.logout_icon : menu.icon
                }
                className={`_svg menu --${
                  menu.label === "user" && !token ? "logout" : menu.label
                }`}
              />
              {menu.label === "cart" && isOpenCartDropdown && <CartDropdown />}
            </Col>
          ))}
        </Row>
      </Row>
    </header>
  );
}
